import { Component, Inject } from '@angular/core';
import { FeedBackService } from "../service/FeedBack.service";
import { FeedBackDataModel } from "../../model/index"
import { SecurityService } from '../../Security/security.service';
import { Title } from '@angular/platform-browser';
import { Router } from "@angular/router";

declare var require: any;
@Component({
    selector: 'MentisSoft-FeedBack',
    template: require('../Template/FeedBack.template.html'),
    styles: [require('../Template/FeedBack.css')]
})

export class FeedBackComponent {
    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private _FeedBackervice: FeedBackService, private _titleService: Title, private router: Router) {
    }
    authentication: string = "x";
    PId: string = "1";
    LastVisit: string = "";
    DoctorName: string = "";
    answerdatafeedback: any[] = [];
    dataSource: FeedBackDataModel[] = [];
    viewFeedBack: boolean = false;
    items: FeedBackDataModel[] = [];
    PatientId: string = this._SecurityService.pid;
    currentQuestionType: string = "Q";
    mandatoryErrorMsg: string = "";
    mandatoryQuesId: FeedBackDataModel[] = [];
    FeedBackStatusMessage: string = "";
    selectedIndex: number;
    selectedQid: number;
	opNo : string;
    ngAfterViewInit(): void {
        $('#overlay').hide();
        this._titleService.setTitle("FeedBack ");
        this.LoadFeedBackStatus();
    }
    private handleError(error: any) {
        console.log("error : " + error);
    }

    LoadFeedBack() {
        var PatientId = "01";
        this._FeedBackervice.getFeedBackData(PatientId, this.authentication, this.PId, this._SecurityService.IsAdminUser)
            .subscribe(
            p => {
                if (p.SessionTimeout != "Session Expired" && p != null) {
                    this.dataSource = p.FeedBacks;

                    if (p.FeedBacks.length > 0) {
                        this.viewFeedBack = true;
                        for (var i = 0; i < p.FeedBacks.length; i++) {
                            if (p.FeedBacks[i].AnswerType == this.currentQuestionType) {
                                this.items.push(p.FeedBacks[i]);
                            }
                        }
                        this.mandatoryQuesId = this.items;
                    }
                }
                else if(p == null || p.SessionTimeout == "Session Expired") {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                console.log("Error while getting data...");
            }

            );
    }
    LoadFeedBackStatus() {
        var PatientId = "01";
        this._FeedBackervice.GetFeedbackStatus(this.PatientId, this.PId, this.authentication, this._SecurityService.IsAdminUser)
            .subscribe(
            p => {
                if (p != null) {
                    this.LastVisit = p.LastVisit;
                    this.DoctorName=p.DoctorName
					this.opNo = p.opNo;
                    if (p.RST == "1") {
                        this.LoadFeedBack();
                    }
                    else if(p == null || p.SessionTimeout == "Session Expired") {
                        this.FeedBackStatusMessage = "Your feedback for last visit is already submitted. Thank You!";
                    }
                }
                else {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                console.log("Error while getting data...");
            }

            );
    }

    moveBack(event) {
        this.items = [];
        this.viewFeedBack = true;
        this.mandatoryErrorMsg = "";
        for (var i = 0; i < this.dataSource.length; i++) {
            if (this.dataSource[i].AnswerType == this.currentQuestionType) {
                this.items.push(this.dataSource[i]);
            }
        }
    }

   

    answerClicked(answerType, qId, ansId, parentindex, WeightAge) {
        this.selectedIndex = WeightAge;
        this.selectedQid = qId;
        for (var i = 0; i < this.dataSource.length; i++) {
            if (this.dataSource[i].QId == qId) {
                this.dataSource[i].selectedWeightAge = WeightAge;
            }
        }

        this.mapDataset(answerType, qId, ansId, parentindex, WeightAge);
    }

    mapDataset(answerType, qId, ansId, parentindex, FeedText) {
        var splitAnsId = ansId.split(',')[parentindex];
        if (this.answerdatafeedback.length > 0) {
            if (this.answerdatafeedback.findIndex(x => x.QId === qId) != -1) {
                this.answerdatafeedback[this.answerdatafeedback.findIndex(x => x.QId === qId)] = {
                    'QId': qId,
                    'AnswerType': answerType,
                    'PatientId': this.PatientId,
                    'AnsId': splitAnsId,
                    'FeedText': FeedText
                };

            }
            else {
                this.answerdatafeedback.push({
                    'QId': qId,
                    'AnswerType': answerType,
                    'PatientId': this.PatientId,
                    'AnsId': splitAnsId,
                    'FeedText': FeedText
                });
            }
        }
        else {
            this.answerdatafeedback.push({
                'QId': qId,
                'AnswerType': answerType,
                'PatientId': this.PatientId,
                'AnsId': splitAnsId,
                'FeedText': FeedText
            });
        }
    }

    submitFeedback(AnswerType) {
        if (AnswerType == "Q" && this.answerdatafeedback.length < this.mandatoryQuesId.length) {
            this.mandatoryErrorMsg = "Mandatory Questions!";
            return false;
        }
        else if (AnswerType == "Q" && this.answerdatafeedback.length == this.mandatoryQuesId.length) {
            this.SubmitAllFeedbackData();
        }
        else {
            this.SubmitAllFeedbackData();
        }
    }
    TextEnterMethod(qId, value: string) {
        let tt = value;
        for (var i = 0; i < this.dataSource.length; i++) {
            if (this.dataSource[i].QId == qId) {
                this.dataSource[i].FeedText = value;
            }
        }
        this.mapDataset("T", qId, "", 0, value)
    }

    radioClick(qId, rdValue, ansId) {
        for (var i = 0; i < this.dataSource.length; i++) {
            if (this.dataSource[i].QId == qId) {
                this.dataSource[i].FeedText = rdValue;
            }
        }
        this.mapDataset("Q", qId, ansId, 0, 0)
    }

    SubmitAllFeedbackData() {
        this._FeedBackervice.SaveFeedback(this.answerdatafeedback, this.PatientId, this.PId, this.authentication, this._SecurityService.IsAdminUser)
            .subscribe(
            p => {
                if (p.SessionTimeout != "Session Expired") {
                    if (p.Isvalid == true) {
                        this.FeedBackStatusMessage = "Thank you for submitting your feedback! we will keep working to give you the best from our side!";
                        this.items = [];
                        this.mandatoryErrorMsg = "";
                    }
                    else {
                        this.mandatoryErrorMsg = "";
                        this.FeedBackStatusMessage = "Something went wrong!";
                    }
                }
                else if(p.SessionTimeout == "Session Expired") {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                this.mandatoryErrorMsg = "";
                this.FeedBackStatusMessage = "Something went wrong!";
                console.log("Error while getting data...");
            }

            );
    }
    moveForward(AnswerType) {
        if (AnswerType == "Q" && this.answerdatafeedback.length < this.mandatoryQuesId.length) {
            this.mandatoryErrorMsg = "Mandatory Questions!"; return false;
        }
        else {
            this.mandatoryErrorMsg = "";
            this.viewFeedBack = false;
            this.items = [];
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.dataSource[i].AnswerType != this.currentQuestionType) {
                    this.items.push(this.dataSource[i]);
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/FeedBack/Component/FeedBack.Component.ts